export default function setDifference(a, b) {
  // A \ B
  return new Set([...a].filter((x) => !b.has(x)));
}
